module.exports = __webpack_public_path__ + "static/media/display05.375ef4b7.jpg";